import { DashboardDataQuery } from 'src/apps/dashboard/services/queries/dashboard/DashboardData.generated';
import { DashboardData } from 'src/apps/dashboard/services/queries/dashboard/DashboardData.gql';
import { buildDashboardDataVariables } from 'src/apps/dashboard/services/queries/dashboard/helpers/buildVariables';
import {
	DashboardDataResult,
	transformDashboardDataResults
} from 'src/apps/dashboard/services/queries/dashboard/helpers/transformResults';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { gqlClient } from 'src/common/services/api/GraphQLRequestApi';
import { Logger } from 'src/common/services/Logger';
import { LabelsExcludedFromDashboard } from 'src/common/types/ConfigurationTypes';

export const getDashboardData = async (
	days: number,
	filters?: IFilterOptions,
	labelsExcludedFromDashboard?: LabelsExcludedFromDashboard
): Promise<DashboardDataResult> => {
	try {
		const variables = buildDashboardDataVariables(days, filters, labelsExcludedFromDashboard);

		const result = await gqlClient.request<DashboardDataQuery>(DashboardData, variables);

		const transformedResult = transformDashboardDataResults(result, days);
		return transformedResult;
	} catch (e) {
		Logger.error('DashboardService -> getDashboardData failed with an error:', e);
		throw e;
	}
};
